import React, { Component } from 'react';
import { Load, LabelWithArrow } from './common/basic';
import DatePicker from './common/datepicker';
import { TableHeaderColumn } from 'react-bootstrap-table';
import DataGrid from './common/dataGrid';
import UserSearch from './common/userSearch';
import DropDown from './common/dropDown';
import { CheckBox, ApplyAndReset } from './common/forms';
import moment from 'moment';
import '../public/less/forms.less';
import { Button } from 'react-bootstrap';
import enums from '../config/enums';
import CSVExport from './common/CSVExport';
import dateHelper from '../helpers/date.js';

// Search Panel
class PatientSearch extends Component {

    constructor(props) {
        super(props);

        this.state = getDefaultParams();
    };

    getSearchParams() {
        var params = this.state;

        params.patient = this
            ._patientSearch
            .getUser();

        if (this.props.userTypeID != enums.USER_TYPE.DOCTOR) {
            params.doctor = this
                ._doctorSearch
                .getUser();
        }

        this.setSearchParams(params);

        return params;
    }

    setSearchParams(params) {
        this.setState(params);
    }

    changeFrom(date) {
        this.setState({ fromDate: date });
    }

    changeTo(date) {
        this.setState({ toDate: date });
    }

    render() {
        var patientClass = "float-left ";
        var doctorSearch = [];
        const SearchContainerStyle = {
            width: '850px',
            height: '120px'
        };
        if (this.props.userTypeID != enums.USER_TYPE.DOCTOR) {
            doctorSearch = <div className='float-left'>
                <h5>Doctor name</h5>
                <UserSearch
                    Value={this.state.doctor}
                    ref={(doctorSearch) => {
                        this._doctorSearch = doctorSearch;
                    }} />
            </div>;
            patientClass += "right-border";
            SearchContainerStyle.width = "960px";
        }



        return (
            <div className='SearchContainer' style={SearchContainerStyle}>
                <div>
                    <div>
                        <div className='float-left right-border '>
                            <DatePicker
                                className='display-table'
                                Label='From date'
                                type="start"
                                startDate={this.state.fromDate}
                                endDate={this.state.toDate}
                                onChange={this
                                    .changeFrom
                                    .bind(this)} />
                            <DatePicker
                                className='display-table'
                                Label='To date'
                                type="end"
                                startDate={this.state.fromDate}
                                endDate={this.state.toDate}
                                ContainerType='input'
                                onChange={this
                                    .changeTo
                                    .bind(this)} />
                        </div>
                        <div className={patientClass}>
                            <h5>Patient name</h5>
                            <UserSearch
                                Value={this.state.patient}
                                ref={(patientSearch) => {
                                    this._patientSearch = patientSearch;
                                }} />
                        </div>
                        {doctorSearch}
                        <div className='float-left'>
                            <ApplyAndReset
                                Search={this
                                    .props
                                    .Search
                                    .bind(this)}
                                ApplyReset={this
                                    .props
                                    .ApplyReset
                                    .bind(this)} />
                        </div>

                        <div className='float-left'>
                                <CSVExport 
                                ajaxUrl='/data/getPatients' 
                                parameters={this.state} 
                                dbKeys={['TimeStamp', 'Patient', 'DeviceType', 'Doctor']} 
                                csvKeys={['Last advice date', 'Patient name', 'Device Type', 'Doctor name']}
                                fileName={'Patients_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>
                        </div>

                        {/* {doctorName} */}
                        <TableHeaderColumn dataField='' dataFormat={moreInfoFormatter}></TableHeaderColumn>
                    </div>
                </div>
            </div>
        )
    }
}

module.exports = class Patients extends Component {
    constructor(props) {
        super(props);

        this.state = getDefaultParams();
    }

    Search() {
        var params = this
            ._patientSearch
            .getSearchParams();

        this.setState({ params });
        this
            ._dataGrid
            .setNewParameters(this.GetParams(params));
    }

    ApplyReset() {
        this.setState(getDefaultParams());

        this
            ._dataGrid
            .setNewParameters(getDefaultParams());

        this
            ._patientSearch
            .setSearchParams(getDefaultParams());
    }

    GetParams(params) {
        var params = {
            fromDate: params
                .fromDate
                .toLocaleDateString(),
            toDate: params
                .toDate
                .toLocaleDateString(),
            patientText: params.patient.text,
            patientID: params.patient.ID,
            doctorText: params.doctor.text,
            doctorID: params.doctor.ID
        }
        return params;
    }

    render() {
        var params = this.GetParams(this.state);
        var doctorName = this.props.params.userTypeID != enums.USER_TYPE.DOCTOR ? <TableHeaderColumn dataField='Doctor' dataSort>Doctor name</TableHeaderColumn> : [];

        return (
            <div className='container'>
                <PatientSearch
                    ref={(patientSearch) => {
                        this._patientSearch = patientSearch;
                    }}
                    ApplyReset={this
                        .ApplyReset
                        .bind(this)}
                    Search={this
                        .Search
                        .bind(this)} userTypeID={this.props.params.userTypeID} />
                <div>
                    <DataGrid
                        ref={(dataGrid) => {
                            this._dataGrid = dataGrid;
                        }}
                        ajaxUrl='/data/getPatients'
                        ID='patientsGrid'
                        parameters={params}
                        OnClick={this.rowClick}
                        ExpandableRow={this.isExpandable}
                        trClassFormat={this.trClassFormat}
                        ExpandComponent={this.expandComponent}>
                        <TableHeaderColumn isKey hidden dataField='ID' />
                        <TableHeaderColumn dataField='TimeStamp' dataFormat={dateFormatter} dataSort>Last advice date</TableHeaderColumn>
                        <TableHeaderColumn dataField='Patient' dataSort>Patient name</TableHeaderColumn>
                        {doctorName}
                        <TableHeaderColumn dataField='DeviceType' dataSort>Device Type</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataFormat={moreInfoFormatter}></TableHeaderColumn>

                    </DataGrid>
                </div>
            </div>
        )
    }
};

var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();

function getDefaultParams() {
    const DefaultParams = {
        fromDate: new Date(y, m, 1),
        toDate: new Date(y, m + 1, 0),
        patient: {
            ID: 0,
            text: ''
        },
        doctor: {
            ID: 0,
            text: ''
        }
    }

    return DefaultParams;
}

function dateFormatter(cell, row) {
    return `${moment(new Date(cell)).format("DD.MM.YYYY")}`;
}

/* More Details */
function moreInfoFormatter(cell, row, enumObject, index) {
    var url = '/patient/' + row.UserID;
    return <a href={url}><Button className='hoverpurple btn btn-default'>More Info</Button></a>
}


// WEBPACK FOOTER //
// ./modules/patients.jsx